/* ============================================================
   KRUNCHIE NATURALS — Theme JS (v4)
   - Mobile navigation drawer
   - FAQ accordion
   - Product image thumbnails
   - Product quantity stepper
   - Product variant switcher (basic)
   ============================================================ */

(function () {
  'use strict';

  /* ── MOBILE NAV ────────────────────────────────────────── */
  const hamburger  = document.getElementById('nav-hamburger');
  const mobileNav  = document.getElementById('mobile-nav');
  const mobileClose = document.getElementById('mobile-nav-close');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    mobileClose && mobileClose.focus();
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hamburger && hamburger.focus();
  }

  hamburger    && hamburger.addEventListener('click', openMobileNav);
  mobileClose  && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobileNav();
    }
  });

  /* ── FAQ ACCORDION ─────────────────────────────────────── */
  document.querySelectorAll('.faq-item__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const answer   = document.getElementById(this.getAttribute('aria-controls'));
      const icon     = this.querySelector('.faq-item__icon');

      // Close all other open items
      document.querySelectorAll('.faq-item__question[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          const otherAnswer = document.getElementById(other.getAttribute('aria-controls'));
          const otherIcon   = other.querySelector('.faq-item__icon');
          if (otherAnswer) otherAnswer.hidden = true;
          if (otherIcon)   otherIcon.textContent = '+';
        }
      });

      this.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.hidden = expanded;
      if (icon)   icon.textContent = expanded ? '+' : '−';
    });
  });

  /* ── PRODUCT IMAGE THUMBNAILS ──────────────────────────── */
  const featuredImg = document.getElementById('product-featured-image');
  document.querySelectorAll('.product-media__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!featuredImg) return;
      const url = this.dataset.imageUrl;
      const alt = this.dataset.imageAlt;
      featuredImg.src = url;
      if (alt) featuredImg.alt = alt;
      document.querySelectorAll('.product-media__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* ── PRODUCT VARIANT PICKER ────────────────────────────── */
  // Reads product JSON from <script id="product-json"> injected by main-product.liquid
  const productJsonEl = document.getElementById('product-json');
  if (productJsonEl) {
    try {
      const product   = JSON.parse(productJsonEl.textContent);
      const variantInput = document.getElementById('variant-id-input');
      const addToCartBtn = document.getElementById('add-to-cart');
      const priceEl      = document.getElementById('product-price');

      // Track current option selections
      const selectedOptions = product.options.map(function (_, i) {
        const activeBtn = document.querySelector('[data-option-index="' + i + '"].is-selected');
        return activeBtn ? activeBtn.dataset.optionValue : null;
      });

      function findVariant(options) {
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === options[i];
          });
        });
      }

      const featuredImgEl = document.getElementById('product-featured-image');
      const thumbBtns = document.querySelectorAll('.product-media__thumb');

      function updateVariantUI(variant) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (addToCartBtn) {
          addToCartBtn.disabled = !variant.available;
          addToCartBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        if (priceEl) {
          const money = function (cents) { return '$' + (cents / 100).toFixed(2); };
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML =
              '<span class="product-price__sale">' + money(variant.price) + '</span>' +
              '<span class="product-price__compare">' + money(variant.compare_at_price) + '</span>';
          } else {
            priceEl.innerHTML = '<span class="product-price__regular">' + money(variant.price) + '</span>';
          }
        }
        if (variant.featured_image && featuredImgEl) {
          featuredImgEl.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
          featuredImgEl.alt = variant.featured_image.alt || product.title;
          thumbBtns.forEach(function (t) {
            const isMatch = t.dataset.imageUrl && variant.featured_image.src &&
              t.dataset.imageUrl.split('?')[0].split('_')[0] === variant.featured_image.src.split('?')[0].split('.')[0];
            t.classList.toggle('is-active', isMatch);
          });
        }
      }

      document.querySelectorAll('.variant-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const idx = parseInt(this.dataset.optionIndex, 10);
          const val = this.dataset.optionValue;
          selectedOptions[idx] = val;

          // Update active state within this option group
          document.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) {
            b.classList.toggle('is-selected', b.dataset.optionValue === val);
          });

          const matched = findVariant(selectedOptions);
          if (matched) updateVariantUI(matched);
        });
      });

    } catch (e) {
      console.warn('[Theme] Could not parse product JSON', e);
    }
  }

  /* ── QUANTITY STEPPERS (product page) ──────────────────── */
  document.querySelectorAll('.product-qty .qty-stepper__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-stepper').querySelector('.qty-stepper__input, input[type="number"]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      const min     = parseInt(input.min, 10) || 1;
      if (this.dataset.action === 'increase') {
        input.value = current + 1;
      } else if (this.dataset.action === 'decrease') {
        input.value = Math.max(min, current - 1);
      }
    });
  });

  /* ── CART PAGE QTY STEPPERS ────────────────────────────── */
  document.querySelectorAll('.cart-page-form .qty-stepper__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-stepper').querySelector('input[type="number"]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      if (this.dataset.action === 'increase') {
        input.value = current + 1;
      } else if (this.dataset.action === 'decrease') {
        input.value = Math.max(0, current - 1);
      }
    });
  });

  /* ── ADD-TO-CART AJAX ──────────────────────────────────── */
  // Intercepts the product form submit, adds via AJAX, fires cart:item-added
  // so the cart drawer opens automatically.
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(this);
      const data     = {};
      formData.forEach(function (val, key) { data[key] = val; });

      const btn = document.getElementById('add-to-cart');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: data.id, quantity: parseInt(data.quantity, 10) || 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:item-added'));
        })
        .catch(function (err) { console.error('[Theme] Add to cart error', err); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        });
    });
  }

})();
